/* Auto-built from nemiLeader.json — every function of the contract is covered. */
import { fmt } from "../shared/format";

export const readFunctions = [
  {
    name: "buyerPayoutPercents",
    title: "Buyer Payout Percents",
    description: "Raw payout share for a rank as stored by the contract.",
    icon: "🛒",
    category: "Income & Percentages",
    inputs: [
      { name: "arg0", type: "uint256", label: "Index", placeholder: "Enter value", required: true },
    ],
  },
  {
    name: "buyerPoolByCycle",
    title: "Buyer Pool By Cycle",
    description: "Read `buyerPoolByCycle` from the contract",
    icon: "🛒",
    category: "Leaderboard",
    inputs: [
      { name: "arg0", type: "uint256", label: "Index", placeholder: "Enter value", required: true },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "buyerVolume",
    title: "Buyer Volume",
    description: "Read `buyerVolume` from the contract",
    icon: "🛒",
    category: "Leaderboard",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "buyerVolumeCycle",
    title: "Buyer Volume Cycle",
    description: "Read `buyerVolumeCycle` from the contract",
    icon: "🛒",
    category: "Leaderboard",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "getTopBuyers",
    title: "Get Top Buyers",
    description: "The top 5 buyers of a given cycle with their volume.",
    icon: "🥇",
    category: "Leaderboard",
    inputs: [
      { name: "cycle", type: "uint256", label: "Cycle", placeholder: "Enter cycle", required: true },
    ],
    formatOutput: (v) =>
      (v || [])
        .map((row, i) =>
          [
            `#${i + 1}`,
            `  account: ${row.account ?? row[0]}`,
            `  volume: ${fmt.amount(row.volume ?? row[1])} USDT`,
          ].join("\n")
        )
        .join("\n"),
  },
  {
    name: "globalCycle",
    title: "Global Cycle",
    description: "Read `globalCycle` from the contract",
    icon: "⏱️",
    category: "Timing",
    inputs: [],
  },
  {
    name: "globalLastDraw",
    title: "Global Last Draw",
    description: "Read `globalLastDraw` from the contract",
    icon: "🔹",
    category: "Timing",
    inputs: [],
    formatOutput: (v) => fmt.time(v),
  },
  {
    name: "globalMarketPlaceReward",
    title: "Global Market Place Reward",
    description: "Read `globalMarketPlaceReward` from the contract",
    icon: "💰",
    category: "Rewards",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "globalMatrixReward",
    title: "Global Matrix Reward",
    description: "Read `globalMatrixReward` from the contract",
    icon: "💰",
    category: "Rewards",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "globalPeriod",
    title: "Global Period",
    description: "Read `globalPeriod` from the contract",
    icon: "⏱️",
    category: "Timing",
    inputs: [],
    formatOutput: (v) => fmt.duration(v),
  },
  {
    name: "lastRedeemedCycle",
    title: "Last Redeemed Cycle",
    description: "Read `lastRedeemedCycle` from the contract",
    icon: "🎁",
    category: "Leaderboard",
    inputs: [],
  },
  {
    name: "nftMarketPlace",
    title: "NFT Market Place",
    description: "Read `nftMarketPlace` from the contract",
    icon: "🛒",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "nftMatrixContract",
    title: "NFT Matrix Contract",
    description: "Read `nftMatrixContract` from the contract",
    icon: "🌳",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "owner",
    title: "Owner",
    description: "Read `owner` from the contract",
    icon: "👑",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "paused",
    title: "Paused",
    description: "Read `paused` from the contract",
    icon: "⏸️",
    category: "Basic Info",
    inputs: [],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "usdtToken",
    title: "USDT Token",
    description: "Read `usdtToken` from the contract",
    icon: "🪙",
    category: "Basic Info",
    inputs: [],
  },
];

export const writeFunctions = [
  {
    name: "redeemTopAchievers",
    title: "Redeem Top Achievers",
    description: "Close the current cycle and pay out the top 5 buyers.",
    icon: "🎁",
    category: "User Actions",
    inputs: [],
  },
];

export const adminFunctions = [
  {
    name: "addMarketPlaceReward",
    title: "Add Market Place Reward",
    description: "Call `addMarketPlaceReward` on the contract",
    icon: "💰",
    category: "Admin Operations",
    inputs: [
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "addMatrixReward",
    title: "Add Matrix Reward",
    description: "Call `addMatrixReward` on the contract",
    icon: "💰",
    category: "Admin Operations",
    inputs: [
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "initialize",
    title: "Initialize",
    description: "Call `initialize` on the contract",
    icon: "⚙️",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [
      { name: "initialOwner", type: "address", label: "Initial Owner", placeholder: "0x…", required: true },
      { name: "newUsdtToken", type: "address", label: "New USDT Token", placeholder: "0x…", required: true },
      { name: "nftMarketPlaceContract", type: "address", label: "NFT Market Place Contract", placeholder: "0x…", required: true },
      { name: "newNftMatrixContract", type: "address", label: "New NFT Matrix Contract", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "pause",
    title: "Pause",
    description: "Call `pause` on the contract",
    icon: "⏸️",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "recordTrade",
    title: "Record Trade",
    description: "Call `recordTrade` on the contract",
    icon: "🛒",
    category: "Admin Operations",
    inputs: [
      { name: "buyer", type: "address", label: "Buyer", placeholder: "0x…", required: true },
      { name: "purchaseAmount", type: "uint256", label: "Purchase Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
      { name: "buyerFeeAmount", type: "uint256", label: "Buyer Fee Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "recoverErc20",
    title: "Recover ERC20",
    description: "Call `recoverErc20` on the contract",
    icon: "♻️",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [
      { name: "erc20Token", type: "address", label: "ERC20 Token", placeholder: "0x…", required: true },
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "recoverErc20All",
    title: "Recover ERC20 All",
    description: "Call `recoverErc20All` on the contract",
    icon: "♻️",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [
      { name: "erc20Token", type: "address", label: "ERC20 Token", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "recoverEth",
    title: "Recover ETH",
    description: "Call `recoverEth` on the contract",
    icon: "♻️",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "recoverUsdt",
    title: "Recover USDT",
    description: "Call `recoverUsdt` on the contract",
    icon: "🪙",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "recoverUsdtAll",
    title: "Recover USDT All",
    description: "Call `recoverUsdtAll` on the contract",
    icon: "🪙",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "renounceOwnership",
    title: "Renounce Ownership",
    description: "Call `renounceOwnership` on the contract",
    icon: "👑",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "setGlobalPeriod",
    title: "Set Global Period",
    description: "Call `setGlobalPeriod` on the contract",
    icon: "⏱️",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newGlobalPeriod", type: "uint256", label: "New Global Period", placeholder: "Enter new global period", required: true },
    ],
  },
  {
    name: "setNewNftMarketPlace",
    title: "Set New NFT Market Place",
    description: "Call `setNewNftMarketPlace` on the contract",
    icon: "🛒",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newNftMarketPlace", type: "address", label: "New NFT Market Place", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setNftMatrixContract",
    title: "Set NFT Matrix Contract",
    description: "Call `setNftMatrixContract` on the contract",
    icon: "🌳",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newNftMatrixContract", type: "address", label: "New NFT Matrix Contract", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setPayoutPercents",
    title: "Set Payout Percents",
    description: "Call `setPayoutPercents` on the contract",
    icon: "📊",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newBuyerPayoutPercents", type: "uint256[5]", label: "New Buyer Payout Percents", placeholder: "Enter new buyer payout percents", required: true, isFixedArray: true, arraySize: 5 },
    ],
  },
  {
    name: "setUsdtToken",
    title: "Set USDT Token",
    description: "Call `setUsdtToken` on the contract",
    icon: "🪙",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newToken", type: "address", label: "New Token", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "transferOwnership",
    title: "Transfer Ownership",
    description: "Call `transferOwnership` on the contract",
    icon: "👑",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [
      { name: "newOwner", type: "address", label: "New Owner", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "unpause",
    title: "Unpause",
    description: "Call `unpause` on the contract",
    icon: "▶️",
    category: "Admin Control",
    ownerOnly: true,
    allowWhilePaused: true,
    inputs: [],
  },
];

const topAchieverFunctions = { readFunctions, writeFunctions, adminFunctions };
export default topAchieverFunctions;
